// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EbookCard_card__e9AH\\+ {
  background: #2a2a2a;
  border-radius: 15px;
  overflow: hidden;
  height: 280px;
  display: flex;
  transition: transform 0.3s ease;
  margin-bottom: 1rem;
  /* Add hardware acceleration for iOS */
  transform: translateZ(0);
}

.EbookCard_imageContainer__6VxSd {
  flex: 0 0 40%;
  position: relative;
  overflow: hidden;
  padding: 10px;
  height: 100%;
  /* Explicit background color to prevent iOS grey rendering */
  background-color: #2a2a2a;
}

/* New wrapper for iOS image fix */
.EbookCard_imageWrapper__x2rOe {
  width: 100%;
  height: 100%;
  background-color: #2a2a2a;
  border-radius: 15px;
  overflow: hidden;
}

.EbookCard_image__UC\\+al {
  width: 100%;
  height: 260px;
  object-fit: contain;
  transition: transform 0.3s ease;
  border-radius: 15px;
  cursor: pointer;
  backface-visibility: visible; /* or remove it */
  transform: none;
  will-change: transform;

}

.EbookCard_content__hB56B {
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  width: 60%;
  position: relative;
  align-items: flex-start;
  justify-content: center;
  /* Explicit background color to prevent iOS grey rendering */
  background-color: #2a2a2a;
}

.EbookCard_category__VL0fz {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  padding: 0 15px 5px;
  overflow: hidden;
}

.EbookCard_bookTitle__O5nm9 {
  font-size: 20px;
  line-height: 1.2;
  margin: 0 0 10px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  padding: 0 15px;
  color: #ffffff; /* Explicit text color for iOS */
}

.EbookCard_description__XbRQg {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
  margin: 0 0 15px;
  width: 100%;
  max-width: 100%;
  padding: 0 15px;
}

.EbookCard_buttons__jQHpB {
  display: flex;
  gap: 10px;
  padding: 0 15px;
  margin-top: 1rem;
  width: calc(100% - 30px);
}

.EbookCard_readButton__GZwQD {
  padding: 8px 15px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
  flex: 1 1;
  white-space: nowrap;
  /* Add hardware acceleration for iOS */
  transform: translateZ(0);
}

.EbookCard_readNow__w8r3G {
  background: #ff0000;
  color: white;
}

.EbookCard_readNow__w8r3G:hover {
  background: #dd0000;
}

.EbookCard_details__YCHVU {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.EbookCard_details__YCHVU:hover {
  background: rgba(255, 255, 255, 0.2);
}

@media (max-width: 1024px) {
  .EbookCard_card__e9AH\\+ {
    height: 280px;
  }
  
  .EbookCard_bookTitle__O5nm9 {
    font-size: 18px;
    -webkit-line-clamp: 1;
  }
  
  .EbookCard_buttons__jQHpB {
    margin-top: 1rem;
  }
  
  .EbookCard_readButton__GZwQD {
    padding: 6px 12px;
    font-size: 13px;
  }
}

@media (max-width: 768px) {
  .EbookCard_card__e9AH\\+ {
    flex-direction: row;
    height: auto;
  }
  
  .EbookCard_imageContainer__6VxSd {
    flex: none;
    height: 160px;
    padding: 10px 10px 0;
  }
  
  .EbookCard_category__VL0fz{
    font-size: 12px;
  }
  
  .EbookCard_image__UC\\+al {
    height: 140px;
  }
  
  .EbookCard_content__hB56B {
    width: 100%;
    padding: 10px 0;
  }
  
  .EbookCard_bookTitle__O5nm9 {
    font-size: 16px;
    -webkit-line-clamp: 1;
    margin-bottom: 5px;
  }
  
  .EbookCard_description__XbRQg {
    font-size: 10px;
    margin-bottom: 10px;
  }
}

@media (max-width: 450px) {
  .EbookCard_card__e9AH\\+ {
    height: auto;
  }
  
  .EbookCard_description__XbRQg {
    font-size: 7px;
    margin-bottom: 5px;
  }
  
  .EbookCard_category__VL0fz {
    font-size: 10px;
  }
  
  .EbookCard_imageContainer__6VxSd {
    height: 140px;
  }
  
  .EbookCard_image__UC\\+al {
    height: 120px;
  }
  
  .EbookCard_buttons__jQHpB {
    flex-direction: row;
    gap: 5px;
  }
  
  .EbookCard_bookTitle__O5nm9 {
    font-size: 15px;
  }
  
  .EbookCard_description__XbRQg {
    font-size: 12px;
    margin-bottom: 5px;
  }
  
  .EbookCard_readButton__GZwQD {
    padding: 5px 10px;
    font-size: 7px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/reading/EbookCard.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,sCAAsC;EAEtC,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,4DAA4D;EAC5D,yBAAyB;AAC3B;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,4BAA4B,EAAE,iBAAiB;EAC/C,eAAe;EACf,sBAAsB;;AAExB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,4DAA4D;EAC5D,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,cAAc,EAAE,gCAAgC;AAClD;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,SAAO;EACP,mBAAmB;EACnB,sCAAsC;EAEtC,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;IACrB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;AACF","sourcesContent":[".card {\n  background: #2a2a2a;\n  border-radius: 15px;\n  overflow: hidden;\n  height: 280px;\n  display: flex;\n  transition: transform 0.3s ease;\n  margin-bottom: 1rem;\n  /* Add hardware acceleration for iOS */\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n}\n\n.imageContainer {\n  flex: 0 0 40%;\n  position: relative;\n  overflow: hidden;\n  padding: 10px;\n  height: 100%;\n  /* Explicit background color to prevent iOS grey rendering */\n  background-color: #2a2a2a;\n}\n\n/* New wrapper for iOS image fix */\n.imageWrapper {\n  width: 100%;\n  height: 100%;\n  background-color: #2a2a2a;\n  border-radius: 15px;\n  overflow: hidden;\n}\n\n.image {\n  width: 100%;\n  height: 260px;\n  object-fit: contain;\n  transition: transform 0.3s ease;\n  border-radius: 15px;\n  cursor: pointer;\n  backface-visibility: visible; /* or remove it */\n  transform: none;\n  will-change: transform;\n\n}\n\n.content {\n  padding: 20px 0;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 60%;\n  position: relative;\n  align-items: flex-start;\n  justify-content: center;\n  /* Explicit background color to prevent iOS grey rendering */\n  background-color: #2a2a2a;\n}\n\n.category {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.5);\n  padding: 0 15px 5px;\n  overflow: hidden;\n}\n\n.bookTitle {\n  font-size: 20px;\n  line-height: 1.2;\n  margin: 0 0 10px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  padding: 0 15px;\n  color: #ffffff; /* Explicit text color for iOS */\n}\n\n.description {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.9);\n  line-height: 1.5;\n  margin: 0 0 15px;\n  width: 100%;\n  max-width: 100%;\n  padding: 0 15px;\n}\n\n.buttons {\n  display: flex;\n  gap: 10px;\n  padding: 0 15px;\n  margin-top: 1rem;\n  width: calc(100% - 30px);\n}\n\n.readButton {\n  padding: 8px 15px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  flex: 1;\n  white-space: nowrap;\n  /* Add hardware acceleration for iOS */\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n}\n\n.readNow {\n  background: #ff0000;\n  color: white;\n}\n\n.readNow:hover {\n  background: #dd0000;\n}\n\n.details {\n  background: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\n.details:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n@media (max-width: 1024px) {\n  .card {\n    height: 280px;\n  }\n  \n  .bookTitle {\n    font-size: 18px;\n    -webkit-line-clamp: 1;\n  }\n  \n  .buttons {\n    margin-top: 1rem;\n  }\n  \n  .readButton {\n    padding: 6px 12px;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 768px) {\n  .card {\n    flex-direction: row;\n    height: auto;\n  }\n  \n  .imageContainer {\n    flex: none;\n    height: 160px;\n    padding: 10px 10px 0;\n  }\n  \n  .category{\n    font-size: 12px;\n  }\n  \n  .image {\n    height: 140px;\n  }\n  \n  .content {\n    width: 100%;\n    padding: 10px 0;\n  }\n  \n  .bookTitle {\n    font-size: 16px;\n    -webkit-line-clamp: 1;\n    margin-bottom: 5px;\n  }\n  \n  .description {\n    font-size: 10px;\n    margin-bottom: 10px;\n  }\n}\n\n@media (max-width: 450px) {\n  .card {\n    height: auto;\n  }\n  \n  .description {\n    font-size: 7px;\n    margin-bottom: 5px;\n  }\n  \n  .category {\n    font-size: 10px;\n  }\n  \n  .imageContainer {\n    height: 140px;\n  }\n  \n  .image {\n    height: 120px;\n  }\n  \n  .buttons {\n    flex-direction: row;\n    gap: 5px;\n  }\n  \n  .bookTitle {\n    font-size: 15px;\n  }\n  \n  .description {\n    font-size: 12px;\n    margin-bottom: 5px;\n  }\n  \n  .readButton {\n    padding: 5px 10px;\n    font-size: 7px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `EbookCard_card__e9AH+`,
	"imageContainer": `EbookCard_imageContainer__6VxSd`,
	"imageWrapper": `EbookCard_imageWrapper__x2rOe`,
	"image": `EbookCard_image__UC+al`,
	"content": `EbookCard_content__hB56B`,
	"category": `EbookCard_category__VL0fz`,
	"bookTitle": `EbookCard_bookTitle__O5nm9`,
	"description": `EbookCard_description__XbRQg`,
	"buttons": `EbookCard_buttons__jQHpB`,
	"readButton": `EbookCard_readButton__GZwQD`,
	"readNow": `EbookCard_readNow__w8r3G`,
	"details": `EbookCard_details__YCHVU`
};
export default ___CSS_LOADER_EXPORT___;
